import { RootState } from "../store";

export const appInfo = (state: RootState) => state.appInfo;
